// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Message_shadow__2Kkht","webJobsMessage":"Message_webJobsMessage__3NZ86","downloadLink":"Message_downloadLink__2n05e"};